import { render } from "./Plan.vue?vue&type=template&id=f88f5332"
const script = {}
script.render = render

export default script